import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireAuth, requireModuleAccess, MODULE_WORKSPACE } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/workspace/organizations/$orgId")({
  beforeLoad: () => {
    requireAuth()();
    requireModuleAccess(MODULE_WORKSPACE)();
  },
  component: () => <Outlet />,
});
